<template>
  <div>
    <el-form ref="schemeRentInfoBox" :model="schemeRentInfo_model" :rules="schemeRentInfo_formRule" class="mt16 form-box" label-position="top">
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="租赁类型" prop="rentCategory">
            <template slot="label">
              <label>租赁类型</label>
              <el-tooltip effect="dark" placement="top" style="margin-left: 4px">
                <i class="QS-icon-question-outline"></i>
                <template #content>
                  <span v-html="CATEGORY_CODE_DESCRIPTION"></span>
                </template>
              </el-tooltip>
            </template>
            <template v-if="disabled">
              {{ getCategoryName }}
            </template>
            <el-select
              v-else
              v-model="schemeRentInfo_model.rentCategory"
              placeholder="请选择"
              @change="rentCategoryChanged">
              <el-option
                v-for="(item,index) in categoryData"
                :key="index"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <div class="form-box__periods">
            <el-form-item label="租期" prop="rentPeriod" class="form-box__periods__input">
              <template v-if="schemeRentInfo_model.rentPeriodType === 3">
                <el-input
                  key="rentPeriod-type-month"
                  v-model="schemeRentInfo_model.rentPeriod"
                  v-integerNumber="{
                    min: 1,
                    max: 60,
                  }"
                  @change="updateData"
                  placeholder="请输入月数"/>
              </template>
              <template v-else>
                <el-input
                  key="rentPeriod-type-day"
                  v-model="schemeRentInfo_model.rentPeriod"
                  v-integerNumber="{
                    min: 1,
                    max: 365,
                  }"
                  @change="updateData"
                  placeholder="请输入天数"/>
              </template>
            </el-form-item>
            <el-form-item class="form-box__periods__select">
              <el-select v-model="schemeRentInfo_model.rentPeriodType" @change="changeRentPeriod">
                <el-option :value="3" label="个月"></el-option>
                <el-option :value="1" label="天"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item :label="payModeLabel" prop="payMode">
            <el-select
              v-model="schemeRentInfo_model.payMode"
              placeholder="请选择"
              @change="payModeChange">
              <el-option v-for="item in payModeList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="赠送天数" prop="presentDays" class="presentDays-item">
            <el-input
              v-model="schemeRentInfo_model.presentDays"
              @input="updateData"
              placeholder="请输入0~365之间的数字"
              v-integerNumber="{
                min: 0,
                max: 365,
              }">
              <span slot="append">天</span>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="前置免租天数" prop="preFreeRentDays" class="presentDays-item">
            <el-input
              v-model="schemeRentInfo_model.preFreeRentDays"
              @input="updateData"
              placeholder="请输入0~365之间的数字"
              v-integerNumber="{
                min: 0,
                max: 365,
              }">
              <span slot="append">天</span>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import {
  CATEGORY_CODE_DESCRIPTION,
  CATEGORY_CODE_MAP,
  PAY_MODE,
  PAY_MODE_BY_DRIVER_COOPERATION,
  PAY_MODE_BY_DRIVER_COOPERATION_TEXT,
  PAY_MODE_TEXT,
  RENT_PERIOD_TYPE,
} from '@/config/rentConfig'
import { CATEGORY_FEE_MAP, FEE_CODE_MAP } from '@/store/dict/rentPlanDict.js'
import SelectOption from '@/store/dict/selectOptionDict'
import { dict2list } from '@/utils/index.js'
import isNil from 'lodash/isNil'
import { mapState } from 'vuex'
import rentInfoFn from './config/schemeRentInfo.js'

// 排序权重
const ORDER_MAP = {
  [PAY_MODE.FULL_MOON]: 1,
  [PAY_MODE.NATURAL_MONTH]: 2,
  [PAY_MODE.WEEK]: 3,
  [PAY_MODE.NATURAL_WEEK]: 4,
  [PAY_MODE.DAY]: 5,
}
const DRIVER_ORDER_MAP = {
  [PAY_MODE_BY_DRIVER_COOPERATION.MONTH]: 1,
  [PAY_MODE_BY_DRIVER_COOPERATION.WEEK]: 2,
  [PAY_MODE_BY_DRIVER_COOPERATION.DAY]: 3,
}
export default {
  name: 'SchemeRentInfo',
  props: {
    defaultRentInfo: {
      type: Object,
      default: () => ({
        rentCategory: '', // 类别
        rentPeriod: '', // 预计租赁周期
        presentDays: 0, // 赠送天数
        preFreeRentDays: 0, // 前置免租天数
      }),
    },
    tableData: {
      type: Array,
      default: () => ([]),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const {
      schemeRentInfo_model,
      schemeRentInfo_formRule,
    } = rentInfoFn.call(this)
    return {
      SelectOption,
      schemeRentInfo_model: {
        ...schemeRentInfo_model,
        rentCategory: '',
      },
      schemeRentInfo_formRule,
      rentPeriodType: 'select',
      // 方案收费list
      feeTableData: [],
      CATEGORY_CODE_DESCRIPTION,
    }
  },
  watch: {
    defaultRentInfo: {
      handler(val) {
        this.syncDefaultRentInfo(val)
      },
      deep: true,
      immediate: true,
    },
    tableData: {
      handler(val) {
        if (!val.length) return
        //  根据【类别】获取不同类别对应的费项
        const someFeeList = this[CATEGORY_FEE_MAP[Number(this.schemeRentInfo_model.rentCategory)]]
        if (someFeeList && someFeeList.length) {
          this.setFeeItemArr(someFeeList, val)
        } else {
          this.$store.dispatch('getFeeList', { type: CATEGORY_FEE_MAP[Number(this.schemeRentInfo_model.rentCategory)] }).then((res) => {
            this.setFeeItemArr(res.data, val)
          })
        }
      },
      deep: true,
    },
    payModeList: {
      handler(val) {
        if (val.length === 1) {
          this.schemeRentInfo_model.payMode = val[0].value
          // 去除该项表单校验
          this.$refs.schemeRentInfoBox.clearValidate('payMode')
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      categoryList: (state) => state.rentPlan.categoryList, // 类别
      orderSignRentFee: (state) => state.rentPlan.orderSignRentFee, // 租车费项
      orderSignPurchaseFee: (state) => state.rentPlan.orderSignPurchaseFee, // 已租代购费项
      orderSignCooperateFee: (state) => state.rentPlan.orderSignCooperateFee, // 司机合作模式费项
    }),
    schemeRentInfo_formConfig() {
      const { schemeRentInfo_formConfig } = rentInfoFn.call(this)
      return schemeRentInfo_formConfig
    },
    categoryData() {
      return this.categoryList
    },
    // 获取收款方式列表
    payModeList() {
      const { rentCategory, rentPeriodType } = this.schemeRentInfo_model
      // 租赁类型为纯租或者以租代购，租期类型为月时，收款方式为：月付（自然月）月付（满月）满周 自然周 日付
      if (rentCategory === CATEGORY_CODE_MAP.ZU_CHE || rentCategory === CATEGORY_CODE_MAP.YI_ZU_DAI_GOU) {
        return dict2list(PAY_MODE_TEXT).map((item) => {
          if (item.value === PAY_MODE.WEEK) return { ...item, name: '周付(满周)' }
          return item
        }).sort((a, b) => this.compareByCustomOrder(a, b, ORDER_MAP))
      }
      // 租赁类型为司机合作模式，租期类型为月时，收款方式为：月结、周结、日结
      if (rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
        return dict2list(PAY_MODE_BY_DRIVER_COOPERATION_TEXT).sort((a, b) => this.compareByCustomOrder(a, b, DRIVER_ORDER_MAP))
      }
      return []
    },
    getCategoryName() {
      const { rentCategory } = this.schemeRentInfo_model
      const tempItem = this.categoryData.find((item) => item.code === rentCategory)
      return tempItem?.name || ''
    },
    payModeLabel() {
      return this.schemeRentInfo_model.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI ? '结算周期' : '收款方式'
    },
  },
  mounted() {
    // 获取类别list
    if (this.categoryList === null || !this.categoryList.length) {
      this.$store.dispatch('getRentCategory')
    }
    if (this.$route.query.id) {
      this.queryFeeList()
    } else {
      this.queryFeeList(this.addRequiredFee)
    }
  },
  methods: {
    syncDefaultRentInfo(val = {}) {
      const rentInfoKey = ['rentCategory', 'rentPeriod', 'presentDays', 'preFreeRentDays', 'rentPeriodType', 'payMode']
      let hasChanged = false
      rentInfoKey.forEach((key) => {
        if (
          Object.prototype.hasOwnProperty.call(val, key) &&
          this.schemeRentInfo_model[key] !== val[key]
        ) {
          this.schemeRentInfo_model[key] = val[key]
          hasChanged = true
        }
      })
      if (hasChanged) {
        this.updateData()
      }
    },
    payModeChange() {
      if (this.schemeRentInfo_model.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
        this.formChange()
      }
      this.queryFeeList(this.addRequiredFee)
      this.updateData()
    },
    formChange() {
      this.$emit('formChange')
    },
    rentCategoryChanged(val) {
      // 清空收款方式、租期、租期类型
      this.schemeRentInfo_model.payMode = ''
      this.schemeRentInfo_model.rentPeriod = ''
      this.schemeRentInfo_model.rentPeriodType = RENT_PERIOD_TYPE.MONTH
      if (val !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
        this.queryFeeList(this.addRequiredFee)
      }
      this.updateData()
      this.$refs.schemeRentInfoBox.validateField('payMode')
    },
    // 请求费项列表
    queryFeeList(cb) {
      if (!this.schemeRentInfo_model.rentCategory) {
        return
      }
      const someFeeList = this[CATEGORY_FEE_MAP[this.schemeRentInfo_model.rentCategory]]
      if (!someFeeList || !someFeeList.length) {
        this.$store.dispatch('getFeeList', { type: CATEGORY_FEE_MAP[this.schemeRentInfo_model.rentCategory] }).then((res) => {
          cb && cb(res.data)
        })
      } else {
        cb && cb(someFeeList)
      }
    },
    // 设置必填费项
    addRequiredFee(someFeeList) {
      // 过滤必填费项
      const requiredFee = someFeeList.filter((item) => item.required) || []
      let nf = requiredFee.map((i) => {
        const item = {}
        item.fundType = i.code
        item.name = i.name
        item.required = i.required
        item.toast = i.toast
        item.isConfirm = false
        return item
      })
      // 若类型选的是【以租代购】,(首付款/租金)和(全款)是互斥关系，table默认展示 首付款/租金，全款需过滤掉
      if (Number(this.schemeRentInfo_model.rentCategory) === CATEGORY_CODE_MAP.YI_ZU_DAI_GOU) {
        nf = nf.filter((i) => Number(i.fundType) !== FEE_CODE_MAP.QUAN_KUAN) // 15-全款
      }
      this.feeTableData = nf
      this.updateData()
    },
    setFeeItemArr(someFeeList, schemePlanFeeList) {
      const newArray = []
      const isDataOutdated = ({ amountAccuracy }) => isNil(amountAccuracy) // 检测计租配置数据是不是旧数据

      schemePlanFeeList.forEach((item) => {
        item.type = Number(item.type) || Number(item.fundType) // 费项code
        const newItem = { ...item }
        const findFee = someFeeList.find((i) => Number(i.code) === item.type)
        if (findFee) {
          // 旧版本的数据标识为isConfirm为false
          // 即：旧版本的数据会展示为“未配置”状态，需要打开配置弹窗重新配置，配置后，数据会转换成新格式
          newItem.isConfirm = !isDataOutdated(newItem)
          newItem.toast = findFee.toast // 提示语
          newItem.required = findFee.required // 是否必填费项
          newItem.name = findFee.name // 费项名称
          newItem.fundType = item.type || item.fundType // 费项code（押金，租金......）
          newItem.payMode = item.payMode || item.payMethod // 收款方式
          newItem.advancePayment = item.advancePayment // 提车时需缴纳
          newArray.push(newItem)
        }
      })

      this.feeTableData = newArray
      this.updateData()
    },
    changeRentPeriod(type) {
      this.schemeRentInfo_model.rentPeriodType = type
      this.schemeRentInfo_model.rentPeriod = ''
      this.schemeRentInfo_model.payMode = ''
      if (this.schemeRentInfo_model.rentCategory !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
        this.queryFeeList(this.addRequiredFee)
      }
      this.updateData()
      this.formChange()
    },
    changeGroupRentPeriod(type) {
      this.rentPeriodType = type
      this.schemeRentInfo_model.rentPeriod = ''
    },
    updateData() {
      this.$emit('updateInfo', this.schemeRentInfo_model, this.feeTableData)
    },
    // 获取表单数据
    getFormData() {
      let returnData = false
      this.$refs.schemeRentInfoBox.validate((validate) => {
        if (validate) {
          returnData = {
            rentCategory: Number(this.schemeRentInfo_model?.rentCategory), // 类别
            rentPeriod: Number(this.schemeRentInfo_model?.rentPeriod), // 预计租赁周期
            presentDays: Number(this.schemeRentInfo_model?.presentDays), // 赠送天数
            preFreeRentDays: Number(this.schemeRentInfo_model?.preFreeRentDays), // 前置免租天数
            rentPeriodType: Number(this.schemeRentInfo_model?.rentPeriodType),
            payMode: this.schemeRentInfo_model.payMode,
          }
        } else {
          this.autoAnchorPoint(true)
        }
      })
      return returnData
    },
    // 锚点定位
    autoAnchorPoint(toastFlag) {
      if (toastFlag && !this.schemeRentInfo_model?.rentCategory) {
        this.$message.error('租赁类型不能为空，请先选择“租赁类型”')
      } else if (toastFlag && !this.schemeRentInfo_model?.rentPeriod) {
        this.$message.error('租期不能为空，请先填写“租期”')
      } else if (toastFlag && !this.schemeRentInfo_model?.payMode) {
        this.$message.error('收款方式不能为空，请先选择“收款方式”')
      }
      this.$refs.schemeRentInfoBox.$el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      this.$refs.schemeRentInfoBox.validate().catch(() => {}) // 表单校验
    },
    compareByCustomOrder(a, b, MAP, field = 'value') {
      // 获取两个对象的目标字段值
      const valueA = a[field]
      const valueB = b[field]

      // 从映射中获取权重（未在映射中的值默认最低优先级）
      const weightA = MAP[valueA] ?? Infinity
      const weightB = MAP[valueB] ?? Infinity

      // 按权重升序排序（权重小的排在前面）
      return weightA - weightB
    },
  },
}
</script>
<style lang="scss" scoped>
.mt16 { margin-top: 16px; }
.form-box {
  ::v-deep .el-form-item__label {
    justify-content: flex-start;
  }
  ::v-deep .el-select {
    width: 100%;
  }
  ::v-deep .el-date-editor {
    width: 100%;
  }
  ::v-deep .el-input {
    width: 100%;
  }
  &__periods {
    display: flex;
    width:100%;
    &__input {
      flex: 1;
      ::v-deep .el-input__inner {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        // border-right: 0;
      }
    }
    &__select {
      width: 70px;
      margin-top: 32px;
      ::v-deep .el-input__inner {
        background: #F7F8FA;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left: 0;
      }
    }
  }
  // .presentDays-item {
  //   ::v-deep .el-input__inner {
  //     border-right: 0;
  //     &:focus + .el-input-group__append {
  //       border-color: #276bec;
  //     }
  //     &:hover + .el-input-group__append {
  //       border-color: #276bec;
  //     }
  //   }
  //   ::v-deep .el-input-group__append {
  //     background: transparent;
  //     padding: 0 12px;
  //   }
  // }
}
</style>
